import { Component, OnInit } from '@angular/core';
import { SedsModalAbstractComponent, SedsModalModule } from 'experian-design-system';

@Component({
    selector: 'app-modal-first-access-serasa-alerta',
    templateUrl: './modal-first-access-serasa-alerta.component.html',
    styleUrls: ['./modal-first-access-serasa-alerta.component.scss'],
    imports: [
        SedsModalModule
    ]
})
export class ModalFirstAccessSerasaAlertaComponent extends SedsModalAbstractComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
